import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';

export interface GetReportDownloadResponse {
  presignedUrl: string;
}

export const getReportDownloadUrl = (
  corpId: string,
  exportId: string
): string => `/targetedaudiencesgateway/reporting/${corpId}/report/${exportId}`;

export async function getReportDownloadAPI(
  corpId: string,
  exportId: string
): Promise<GetReportDownloadResponse> {
  const response = await sdk.http.get(getReportDownloadUrl(corpId, exportId));

  return camelizeResponseData(response) as GetReportDownloadResponse;
}
